<mat-card-title class="header-panel" [ngStyle]="{ 'background-color': color, color: fontColor }">
  <div>
    <span class="text-wrap" [innerHTML]="header"></span>
    @if (subHeader) {
      <span class="sub">
        {{ subHeader }}
      </span>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</mat-card-title>
